// Author YuJiaBei
// Date 2025-01-23 15:42:08

class RepairWorkOrder {
    constructor({
                    id = null,
                    workOrderCode = '',
                    rwoIdOrigin = '',
                    rwoCodeBda = '',
                    rwoIdBda = '',
                    status = '',
                    rwoIdRpr = '',
                    rwoCodeRor = '',
                    rwoIdRpl = '',
                    rwoVerifier = '',
                    rwoVerifierRealName = '',
                    rwoLocResp = '',
                    rwoLocRespRealName = '',
                    rwoMainExecutor = '',
                    rwoOtherExecutors = '',
                    rwoRepAcceptor = '',
                    rwoRepAcceptorRealName = '',
                    rwoPrdAcceptor = '',
                    rwoPrdAcceptorRealName = '',
                    rwoStandWorkhour = '',
                    rwoJobContent = '',
                    rwoSafeContent = '',
                    rwoAttachment = '',
                    rwoRemark = '',
                    rwoPlanStartDate = '',
                    rwoPlanEndDate = '',
                    rwoActualStartDate = '',
                    rwoActualFinishDate = '',
                    rwoFinishDate = '',
                    rwoAttachmentList = ''
                }
                    = {}) {
        this.id = id;
        this.workOrderCode = workOrderCode;
        this.rwoIdOrigin = rwoIdOrigin;
        this.rwoCodeBda = rwoCodeBda;
        this.rwoIdBda = rwoIdBda;
        this.status = status;
        this.rwoIdRpr = rwoIdRpr;
        this.rwoCodeRor = rwoCodeRor;
        this.rwoIdRpl = rwoIdRpl;
        this.rwoVerifier = rwoVerifier;
        this.rwoVerifierRealName = rwoVerifierRealName;
        this.rwoLocResp = rwoLocResp;
        this.rwoLocRespRealName = rwoLocRespRealName;
        this.rwoMainExecutor = rwoMainExecutor;
        this.rwoOtherExecutors = rwoOtherExecutors;
        this.rwoRepAcceptor = rwoRepAcceptor;
        this.rwoRepAcceptorRealName = rwoRepAcceptorRealName;
        this.rwoPrdAcceptor = rwoPrdAcceptor;
        this.rwoPrdAcceptorRealName = rwoPrdAcceptorRealName;
        this.rwoStandWorkhour = rwoStandWorkhour;
        this.rwoJobContent = rwoJobContent;
        this.rwoSafeContent = rwoSafeContent;
        this.rwoAttachment = rwoAttachment;
        this.rwoRemark = rwoRemark;
        this.rwoPlanStartDate = rwoPlanStartDate;
        this.rwoPlanEndDate = rwoPlanEndDate;
        this.rwoActualStartDate = rwoActualStartDate;
        this.rwoActualFinishDate = rwoActualFinishDate;
        this.rwoFinishDate = rwoFinishDate;
        this.rwoAttachmentList = rwoAttachmentList;
    }
}

function newEntity() {
    return new RepairWorkOrder();
}

function gridFields() {
    return Object.freeze([
        {
            key: 'id',
            label: 'label.em.repair.repairWorkOrder.grid.id',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'statusName',
            label: 'label.em.repair.repairWorkOrder.grid.statusName',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'workOrderCode',
            label: 'label.em.repair.repairWorkOrder.grid.workOrderCode',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'rwoIdOrigin',
            label: 'label.em.repair.repairWorkOrder.grid.rwoIdOrigin',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'rwoCodeBda',
            label: 'label.em.repair.repairWorkOrder.grid.rwoCodeBda',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'emArchBdaName',
            label: 'label.em.repair.repairWorkOrder.grid.emArchBdaName',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'rwoIdBda',
            label: 'label.em.repair.repairWorkOrder.grid.rwoIdBda',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'priorityName',
            label: 'label.em.repair.repairWorkOrder.grid.priorityName',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'originName',
            label: 'label.em.repair.repairWorkOrder.grid.originName',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'rwoIdRpl',
            label: 'label.em.repair.repairWorkOrder.grid.rwoIdRpl',
            sortable: true,
            isDetail: true,
            form: {
                type: 'entityModalSelect',
                modalMultiSelectedType: 'string'
                , entity: 'repairPlan'
            }
        },
        {
            key: 'rwoCodeRpl',
            label: 'label.em.repair.repairWorkOrder.grid.rwoCodeRpl',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'rwoAuthorRealName',
            label: 'label.em.repair.repairWorkOrder.grid.rwoAuthorRealName',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'rwoVerifierRealName',
            label: 'label.em.repair.repairWorkOrder.grid.rwoVerifierRealName',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'rwoLocRespRealName',
            label: 'label.em.repair.repairWorkOrder.grid.rwoLocRespRealName',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'rwoMainExecutor',
            label: 'label.em.repair.repairWorkOrder.grid.rwoMainExecutor',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'rwoOtherExecutors',
            label: 'label.em.repair.repairWorkOrder.grid.rwoOtherExecutors',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'rwoRepAcceptorRealName',
            label: 'label.em.repair.repairWorkOrder.grid.rwoRepAcceptorRealName',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'rwoPrdAcceptorRealName',
            label: 'label.em.repair.repairWorkOrder.grid.rwoPrdAcceptorRealName',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'rwoStandWorkhour',
            label: 'label.em.repair.repairWorkOrder.grid.rwoStandWorkhour',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'rwoJobContent',
            label: 'label.em.repair.repairWorkOrder.grid.rwoJobContent',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'rwoSafeContent',
            label: 'label.em.repair.repairWorkOrder.grid.rwoSafeContent',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'rwoAttachmentList',
            label: 'label.em.repair.repairWorkOrder.grid.rwoAttachmentList',
            sortable: true,
            isDetail: true,
            form: {
                type: 'emAttachment',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'rwoRemark',
            label: 'label.em.repair.repairWorkOrder.grid.rwoRemark',
            sortable: true,
            isDetail: true,
            form: {
                type: 'textarea',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'rwoSparePartsLists',
            label: 'label.em.repair.repairWorkOrder.grid.rwoSparePartsLists',
            sortable: true,
            isDetail: true,
            form: {
                type: 'textarea'
            }
        },
        {
            key: 'rwoPlanStartDate',
            label: 'label.em.repair.repairWorkOrder.grid.rwoPlanStartDate',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'rwoPlanEndDate',
            label: 'label.em.repair.repairWorkOrder.grid.rwoPlanEndDate',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string',
                customClass: (row) => {
                    //超过一天的的变红
                    if (row.rwoPlanEndDate !== undefined && row.rwoPlanEndDate !== '') {
                        //把字符串格式转化为日期类
                        let planFinishTime = new Date(Date.parse(row.rwoPlanEndDate))
                        //如果不是维修完成，跟现在时间对比，超一天变红
                        //如果是维修完成，跟实际完成时间或者工作流完成时间对比
                        if (row.statusName !== '维修完成') {
                            let warnTime = new Date()
                            warnTime.setDate(warnTime.getDate() - 1);
                            if (planFinishTime < warnTime) {
                                return "bg-danger text-dark"
                            } else {
                                return "";
                            }
                        }
                        // else {
                        //     let finishDate = new Date();
                        //     if (row.rwoActualFinishDate) {
                        //         finishDate =new Date(Date.parse(row.rwoActualFinishDate));
                        //     } else if (row.rwoFinishDate) {
                        //         finishDate =new Date(Date.parse(row.rwoFinishDate));
                        //     }
                        //     finishDate.setDate(finishDate.getDate()-1);
                        //     if (planFinishTime < finishDate) {
                        //         return "bg-danger text-dark"
                        //     } else {
                        //         return "";
                        //     }
                        // }
                    }
                    return ""
                }
            }
        },
        {
            key: 'rwoActualStartDate',
            label: 'label.em.repair.repairWorkOrder.grid.rwoActualStartDate',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'rwoActualFinishDate',
            label: 'label.em.repair.repairWorkOrder.grid.rwoActualFinishDate',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'rwoFinishDate',
            label: 'label.em.repair.repairWorkOrder.grid.rwoFinishDate',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },

    ])
}

const filter = {
    idFilter: '',
    idListFilter: [],
    workOrderCodeFilter: '',
    rwoCodeBdaFilter: '',
    rwoIdBdaFilter: '',
    rwoNameBdaFilter: '',
    statusFilter: '',
    statusNotStartWithFilter: '',
    rwoIdRprFilter: '',
    rwoCodeRorFilter: '',
    rwoIdRplFilter: '',
    rwoAuthorFilter: '',
    rwoAuthorRealNameFilter: '',
    rwoVerifierFilter: '',
    rwoVerifierRealNameFilter: '',
    rwoLocRespFilter: '',
    rwoLocRespRealNameFilter: '',
    rwoMainExecutorFilter: '',
    rwoMainExecutorNameFilter: '',
    rwoOtherExecutorsFilter: '',
    rwoOtherExecutorsNameFilter: '',
    rwoRepAcceptorFilter: '',
    rwoRepAcceptorRealNameFilter: '',
    rwoPrdAcceptorFilter: '',
    rwoPrdAcceptorRealNameFilter: '',
    rwoStandWorkhourFilter: '',
    rwoJobContentFilter: '',
    rwoSafeContentFilter: '',
    rwoPlanStartDateRteFilter: '',
    rwoPlanStartDateLteFilter: '',
    rwoPlanEndDateRteFilter: '',
    rwoPlanEndDateLteFilter: '',
    rwoActualStartDateRteFilter: '',
    rwoActualStartDateLteFilter: '',
    rwoActualFinishDateRteFilter: '',
    rwoActualFinishDateLteFilter: '',
    rwoFinishDateRteFilter: '',
    rwoFinishDateLteFilter: '',
    workflowQueryTypeFilter: ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
    {
        key: 'workOrderCodeFilter',
        label: 'label.em.repair.repairWorkOrder.filter.workOrderCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'rwoCodeBdaFilter',
        label: 'label.em.repair.repairWorkOrder.filter.rwoCodeBda',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'rwoIdBdaFilter',
        label: 'label.em.repair.repairWorkOrder.filter.rwoIdBda',
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'rwoNameBdaFilter',
        label: 'label.em.repair.repairWorkOrder.filter.rwoNameBda',
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'emArchBasicData'
            , correspondingField: 'name'
            , fieldsBindingByEntityModalSelected: '{"rwoIdBda":"id"}'
        }
    },
    {
        key: 'statusFilter',
        label: 'label.em.repair.repairWorkOrder.filter.status',
        disabled: false,
        form: {
            type: 'entitySelect',
            modalMultiSelectedType: 'string'
            , entity: 'emActProcessStatus'
            , showLabelSelectOne: true
            , selectFilter: {processBusinessEntityFilter: 'RepairWorkOrder', statusFilter: 1}
        }
    },
    {
        key: 'rwoIdRprFilter',
        label: 'label.em.repair.repairWorkOrder.filter.rwoIdRpr',
        disabled: false,
        form: {
            type: 'entitySelect',
            modalMultiSelectedType: 'string'
            , entity: 'repairPriority'
            , showLabelSelectOne: true
        }
    },
    {
        key: 'rwoCodeRorFilter',
        label: 'label.em.repair.repairWorkOrder.filter.rwoCodeRor',
        disabled: false,
        form: {
            type: 'entitySelect',
            modalMultiSelectedType: 'string'
            , entity: 'repairOrigin'
            , showLabelSelectOne: true
        }
    },
    {
        key: 'rwoIdRplFilter',
        label: 'label.em.repair.repairWorkOrder.filter.rwoIdRpl',
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'repairPlan'
            , correspondingField: 'id'
        }
    },
    {
        key: 'rwoAuthorRealNameFilter',
        label: 'label.em.repair.repairWorkOrder.filter.rwoAuthorRealName',
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'emAclUser'
            , correspondingField: 'name'
            , fieldsBindingByEntityModalSelected: '{"rwoAuthor":"loginName"}'
        }
    },
    {
        key: 'rwoVerifierRealNameFilter',
        label: 'label.em.repair.repairWorkOrder.filter.rwoVerifierRealName',
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'emAclUser'
            , correspondingField: 'name'
            , fieldsBindingByEntityModalSelected: '{"rwoVerifier":"loginName"}'
        }
    },
    {
        key: 'rwoLocRespRealNameFilter',
        label: 'label.em.repair.repairWorkOrder.filter.rwoLocRespRealName',
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'emAclUser'
            , correspondingField: 'name'
            , fieldsBindingByEntityModalSelected: '{"rwoLocResp":"loginName"}'
        }
    },
    {
        key: 'rwoMainExecutorNameFilter',
        label: 'label.em.repair.repairWorkOrder.filter.rwoMainExecutorName',
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'emAclUser'
            , correspondingField: 'name'
            , fieldsBindingByEntityModalSelected: '{"rwoMainExecutor":"loginName"}'
        }
    },
    {
        key: 'rwoOtherExecutorsNameFilter',
        label: 'label.em.repair.repairWorkOrder.filter.rwoOtherExecutorsName',
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'emAclUser'
            , correspondingField: 'name'
            , fieldsBindingByEntityModalSelected: '{"rwoOtherExecutors":"loginName"}'
        }
    },
    {
        key: 'rwoRepAcceptorRealNameFilter',
        label: 'label.em.repair.repairWorkOrder.filter.rwoRepAcceptorRealName',
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'emAclUser'
            , correspondingField: 'name'
            , fieldsBindingByEntityModalSelected: '{"rwoRepAcceptor":"loginName"}'
        }
    },
    {
        key: 'rwoPrdAcceptorRealNameFilter',
        label: 'label.em.repair.repairWorkOrder.filter.rwoPrdAcceptorRealName',
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'emAclUser'
            , correspondingField: 'name'
            , fieldsBindingByEntityModalSelected: '{"rwoPrdAcceptor":"loginName"}'
        }
    },
    {
        key: 'rwoStandWorkhourFilter',
        label: 'label.em.repair.repairWorkOrder.filter.rwoStandWorkhour',
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'rwoJobContentFilter',
        label: 'label.em.repair.repairWorkOrder.filter.rwoJobContent',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'rwoSafeContentFilter',
        label: 'label.em.repair.repairWorkOrder.filter.rwoSafeContent',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'rwoPlanStartDateRteFilter',
        label: 'label.em.repair.repairWorkOrder.filter.rwoPlanStartDateRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'rwoPlanStartDateLteFilter',
        label: 'label.em.repair.repairWorkOrder.filter.rwoPlanStartDateLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'rwoPlanEndDateRteFilter',
        label: 'label.em.repair.repairWorkOrder.filter.rwoPlanEndDateRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'rwoPlanEndDateLteFilter',
        label: 'label.em.repair.repairWorkOrder.filter.rwoPlanEndDateLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'rwoActualStartDateRteFilter',
        label: 'label.em.repair.repairWorkOrder.filter.rwoActualStartDateRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'rwoActualStartDateLteFilter',
        label: 'label.em.repair.repairWorkOrder.filter.rwoActualStartDateLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'rwoActualFinishDateRteFilter',
        label: 'label.em.repair.repairWorkOrder.filter.rwoActualFinishDateRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'rwoActualFinishDateLteFilter',
        label: 'label.em.repair.repairWorkOrder.filter.rwoActualFinishDateLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'rwoFinishDateRteFilter',
        label: 'label.em.repair.repairWorkOrder.filter.rwoFinishDateRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'rwoFinishDateLteFilter',
        label: 'label.em.repair.repairWorkOrder.filter.rwoFinishDateLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
];
const repairPlanSelectorFilterConfigs = [
    {
        key: 'workOrderCodeFilter',
        label: 'label.em.repair.repairWorkOrder.filter.workOrderCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'rwoCodeBdaFilter',
        label: 'label.em.repair.repairWorkOrder.filter.rwoCodeBda',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'rwoIdBdaFilter',
        label: 'label.em.repair.repairWorkOrder.filter.rwoIdBda',
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'statusFilter',
        label: 'label.em.repair.repairWorkOrder.filter.status',
        disabled: false,
        form: {
            type: 'entitySelect',
            modalMultiSelectedType: 'string'
            , entity: 'emActProcessStatus'
            , showLabelSelectOne: true
            , selectFilter: {processBusinessEntityFilter: 'RepairWorkOrder', statusFilter: 1}
        }
    },
    {
        key: 'rwoCodeRorFilter',
        label: 'label.em.repair.repairWorkOrder.filter.rwoCodeRor',
        disabled: false,
        form: {
            type: 'entitySelect',
            modalMultiSelectedType: 'string'
            , entity: 'repairOrigin'
            , showLabelSelectOne: true
        }
    },
    {
        key: 'rwoPlanStartDateRteFilter',
        label: 'label.em.repair.repairWorkOrder.filter.rwoPlanStartDateRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'rwoPlanStartDateLteFilter',
        label: 'label.em.repair.repairWorkOrder.filter.rwoPlanStartDateLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'rwoPlanEndDateRteFilter',
        label: 'label.em.repair.repairWorkOrder.filter.rwoPlanEndDateRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'rwoPlanEndDateLteFilter',
        label: 'label.em.repair.repairWorkOrder.filter.rwoPlanEndDateLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    }
];


const entityFormConfigs = [
    {
        key: 'rwoCodeBda',
        label: 'label.em.repair.repairWorkOrder.entity.rwoCodeBda',
        sortable: true,
        disabled: false,
        form: {
            type: 'entityModalSelect'
            , required: true
            , entity: 'emArchBasicData'
            , correspondingField: 'code'
            , fieldsBindingByEntityModalSelected: '{"rwoIdBda":"id"}'
        }
    },
    {
        key: 'rwoIdRpr',
        label: 'label.em.repair.repairWorkOrder.entity.rwoIdRpr',
        sortable: true,
        disabled: false,
        form: {
            type: 'entitySelect',
            modalMultiSelectedType: 'string'
            , entity: 'repairPriority'
            , showLabelSelectOne: true
        }
    },
    {
        key: 'rwoCodeRor',
        label: 'label.em.repair.repairWorkOrder.entity.rwoCodeRor',
        sortable: true,
        disabled: false,
        form: {
            type: 'entitySelect',
            modalMultiSelectedType: 'string'
            , entity: 'repairOrigin'
            , showLabelSelectOne: true
        }
    },
    {
        key: 'rwoVerifierRealName',
        label: 'label.em.repair.repairWorkOrder.entity.rwoVerifierRealName',
        sortable: true,
        disabled: false,
        form: {
            type: 'entityModalSelect'
            , required: true
            , entity: 'emAclUser'
            , correspondingField: 'name'
            , fieldsBindingByEntityModalSelected: '{"rwoVerifier":"loginName"}'
        }
    },
    {
        key: 'rwoLocRespRealName',
        label: 'label.em.repair.repairWorkOrder.entity.rwoLocRespRealName',
        sortable: true,
        disabled: false,
        form: {
            type: 'entityModalSelect'
            , required: true
            , entity: 'emAclUser'
            , correspondingField: 'name'
            , fieldsBindingByEntityModalSelected: '{"rwoLocResp":"loginName"}'
        }
    },
    {
        key: 'rwoRepAcceptorRealName',
        label: 'label.em.repair.repairWorkOrder.entity.rwoRepAcceptorRealName',
        sortable: true,
        disabled: false,
        form: {
            type: 'entityModalSelect'
            , required: true
            , entity: 'emAclUser'
            , correspondingField: 'name'
            , fieldsBindingByEntityModalSelected: '{"rwoRepAcceptor":"loginName"}'
        }
    },
    {
        key: 'rwoPrdAcceptorRealName',
        label: 'label.em.repair.repairWorkOrder.entity.rwoPrdAcceptorRealName',
        sortable: true,
        disabled: false,
        form: {
            type: 'entityModalSelect'
            , required: true
            , entity: 'emAclUser'
            , correspondingField: 'name'
            , fieldsBindingByEntityModalSelected: '{"rwoPrdAcceptor":"loginName"}'
        }
    },
    {
        key: 'rwoJobContent',
        label: 'label.em.repair.repairWorkOrder.entity.rwoJobContent',
        sortable: true,
        disabled: false,
        form: {
            type: 'textarea',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'rwoSafeContent',
        label: 'label.em.repair.repairWorkOrder.entity.rwoSafeContent',
        sortable: true,
        disabled: false,
        form: {
            type: 'textarea',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'rwoRemark',
        label: 'label.em.repair.repairWorkOrder.entity.rwoRemark',
        sortable: true,
        disabled: false,
        form: {
            type: 'textarea',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'rwoPlanStartDate',
        label: 'label.em.repair.repairWorkOrder.entity.rwoPlanStartDate',
        sortable: true,
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'rwoPlanEndDate',
        label: 'label.em.repair.repairWorkOrder.entity.rwoPlanEndDate',
        sortable: true,
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'rwoAttachmentList',
        label: 'label.em.repair.repairWorkOrder.entity.rwoAttachment',
        sortable: false,
        disabled: false,
        form: {
            type: 'emAttachment',
            modalMultiSelectedType: 'string'
            , correspondingField: 'rwoAttachment'
        }
    }
]

export {
    RepairWorkOrder, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
    , filterConfigs, repairPlanSelectorFilterConfigs


}
